import * as React from "react"

const EmailContact = (props) => (
  <svg
    width={44}
    height={28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M41.643.643H9.429A2.36 2.36 0 0 0 7.07 3v6.286H3.93a.786.786 0 0 0 0 1.571H7.07v11H3.93a.786.786 0 0 0 0 1.572H7.07V25a2.36 2.36 0 0 0 2.358 2.357h32.214A2.36 2.36 0 0 0 44 25V3A2.36 2.36 0 0 0 41.643.643ZM42.429 25a.787.787 0 0 1-.786.786H9.429A.787.787 0 0 1 8.643 25V3c0-.433.353-.786.786-.786h32.214c.433 0 .786.353.786.786v22ZM0 5.357c0-.434.352-.786.786-.786h3.928a.786.786 0 0 1 0 1.572H.786A.785.785 0 0 1 0 5.357Zm4.714 13.357H.786a.786.786 0 0 1 0-1.571h3.928a.786.786 0 0 1 0 1.571ZM39.177 4.96a.786.786 0 0 1-.279 1.075l-13.357 7.858a.785.785 0 0 1-.815-.011L12.155 6.022a.785.785 0 1 1 .833-1.332l12.167 7.605L38.102 4.68a.785.785 0 0 1 1.075.278Z"
      fill="#fff"
    />
  </svg>
)

export default EmailContact